<div class="modal-header">
  <h4 class="modal-title">Send PDF Password</h4>
  <button type="button" class="close" aria-label="Close" (click)="onCancelClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body about-to-send" *ngIf="pdfLessContacts && pdfLessContacts.length !== 0 && !pdfLessAction">
  <p>
    <span>There {{ this.pdfLessContacts.length == 1 ? 'is' : 'are' }} </span>
    <button class="button-as-anchor" role="button" type="button" (click)="onListMissingContactClick()">{{ this.pdfLessContacts.length }} {{ this.pdfLessContacts.length == 1 ? 'contact' : 'contacts' }}</button>
    <span> without a pdf password.</span>
  </p>
  <ul *ngIf="showPdfLessContacts">
    <li *ngFor="let contact of pdfLessContacts">{{ contact.name }} &lt;{{ contact.email}}&gt;</li>
  </ul>
  <p>
    <span>What do you want to do about this?</span>
  </p>
</div>
<div class="modal-footer" *ngIf="pdfLessContacts && pdfLessContacts.length !== 0 && !pdfLessAction">
  <button type="button" class="btn btn-outline-dark" (click)="onCancelClick()" i18n="@@genericCancelButtonLabel">Cancel</button>
  <button type="button" class="btn btn-info" (click)="onPdfLessActionClick('skip')">Skip missing passwords</button>
  <button type="button" class="btn btn-primary" (click)="onPdfLessActionClick('create')">Autogenerate passwords</button>
</div>

<div class="modal-body sending-or-sent" *ngIf="!(pdfLessContacts && pdfLessContacts.length !== 0 && !pdfLessAction)">
  <p>Sending the PDF password to {{ contactCount }} {{ contactCount == 1 ? 'contact' : 'contacts' }}. {{ progress < 1 ? 'Do not close this dialog.' : '' }}</p>
  <div class="progress main-progress-bar">
    <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" [style.width]="(progress * 100).toFixed(2) + '%'">{{ (progress * 100).toFixed(2) + '%' }}</div>
  </div>
  <div class="alert alert-success" *ngIf="progress >= 1 && errorList.length === 0">
    All emails have been successfully sent. You may close this dialog now.
  </div>
  <ul class="alert alert-danger error-list" *ngIf="errorList.length !== 0">
    <li>There {{ errorList.length === 1 ? 'is' : 'were' }} {{ errorList.length }} errors while sending the pdf passwords:</li>
    <li *ngFor="let error of errorList">
      <a [href]="'mailto:' + error.contactEmail" style="white-space: pre-wrap; font-style: italic !important; color: #a70606;">{{ error.contactName }}</a>
      <span>{{ error.message }}</span>
    </li>
  </ul>
</div>
<div class="modal-footer" *ngIf="!(pdfLessContacts && pdfLessContacts.length !== 0 && !pdfLessAction)">
  <button type="button" class="btn btn-outline-dark" (click)="onCancelClick()">
    <span *ngIf="inProgress && errorList.length === 0">Cancel</span>
    <span *ngIf="!(inProgress && errorList.length === 0)">Close</span>
  </button>
</div>
